"use client";
import { Button } from "@commerce-frontend/ui/base/Button/Button";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Input } from "@commerce-frontend/ui/base/Input/Input";
import { cn } from "@commerce-frontend/ui/utils/classNames";
import { useTranslations } from "next-intl";

type Props = {
	className?: string;
	onClickFakeSearchBar: () => void;
};

export const FakeSearchBar = ({ className, onClickFakeSearchBar }: Props) => {
	const t = useTranslations("SearchBar");

	return (
		<div
			className={cn("relative w-full max-sm:order-1 max-sm:mt-4", className)}
		>
			<Input
				name="q"
				type="search"
				alt={t("mobileAccessibilityName")}
				placeholder={t("placeholder")}
				className="rounded-full focus-visible:outline-0"
				onClick={onClickFakeSearchBar}
			/>
			<Button
				className="absolute right-0 top-0 size-11 rounded-full border-transparent bg-transparent text-black"
				variant="outlined"
				icon={<Icon icon="search" />}
				type="submit"
				title={t("search")}
				disabled
			/>
		</div>
	);
};
